import React, { useEffect, useMemo, useState } from "react";
import Card from "components/card";
import {
  Dialog,
  DialogHeader,
  DialogBody,
  Button,
  Spinner,
} from "@material-tailwind/react";

import { ToastContainer, toast } from "react-toastify";

import DYNAMIC from "./Company_fees_tables/DYNAMIC";

import DYNAMICModale from "./Modales/DYNAMIC_modale";
import {
  getAllCompanyFeesApi,
  getAllCompanyFeesCategoryApi,
} from "api/companyFees";
import { getAllOperatorsApi } from "api/filtersData";
import { pdfCompanyFeeGeneratorApi } from "api/pdf";

function CompanyFeesTable({ accessList }) {
  const [listOfTcp, setListOfTcp] = useState([]);

  const [showCompanyFeesModaleDynamic, setShowCompanyFeesModaleDynamic] =
    useState(false);
  const [selectedDynamicCategory, setSelectedDynamicCategory] = useState(null);
  const [companyFeesCategories, setCompanyFeesCategories] = useState([]);

  const [filtredObject, setFiltredObject] = useState({
    typeOfOp: "ALL", // ALL = tous, ou DYNAMIC:<categoryId>
    isAproved: "",
    isJustify: "",
    responsable: "",
    // kept empty (no UI control) so the API query string isn't built with
    // literal "undefined" values — static-type filters are no longer shown
    cvValidationStaus: "",
    fdValidationStatus: "",
    tlValidationStatus: "",
    evenementsValidationStatus: "",
    avocatValidationStatus: "",
    details: "",
    dgValidationStatus: "",
    description: "",
    selectedFromDate: `${new Date().getFullYear()}-01-01`,
    selectedToDate: `${new Date().getFullYear()}-12-31`,
    excludedDates: [],
    docStatus: "",
    payeStatus: "",
  });

  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getFilterData();
  }, []);

  useEffect(() => {
    getAllCompanyFees(filtredObject);
  }, []);

  useEffect(() => {
    getAllCompanyFeesCategory();
  }, []);

  const getAllCompanyFeesCategory = async () => {
    try {
      const response = await getAllCompanyFeesCategoryApi();
      setCompanyFeesCategories(response);
    } catch (err) {
      console.log(err);
    }
  };

  const getFilterData = async () => {
    try {
      const response = await getAllOperatorsApi();
      setListOfTcp(response);
    } catch (err) {
      console.log(err);
    }
  };

  const refreshTableData = async () => {
    getAllCompanyFees(filtredObject);
  };

  const getAllCompanyFees = async (filtredObject) => {
    try {
      setIsLoading(true);
      const response = await getAllCompanyFeesApi(filtredObject);
      setTableData(response);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFiltersInputChange = (e) => {
    const { name, value } = e.target;
    setFiltredObject((prevInputFilterValue) => ({
      ...prevInputFilterValue,
      [name]: value,
    }));

    if (name === "isAproved") filtredObject.isAproved = value;

    if (name === "isJustify") filtredObject.isJustify = value;

    if (name === "responsable") {
      filtredObject.responsable = value;

      // Refetch immediately so all tables (including dynamic fees) are refiltered
      getAllCompanyFees(filtredObject);
    }

    if (name === "typeOfOp") {
      filtredObject.typeOfOp = value;

      // Refetch immediately: the displayed table switches with the type,
      // so the data must be refiltered without waiting for "Filtrer"
      getAllCompanyFees(filtredObject);
    }

    if (name === "selectedFromDate") filtredObject.selectedFromDate = value;

    if (name === "selectedToDate") filtredObject.selectedToDate = value;

    if (name === "payeStatus") filtredObject.payeStatus = value;

    if (name === "dgValidationStatus") filtredObject.dgValidationStatus = value;

    if (name === "docStatus") filtredObject.docStatus = value;
  };

  const handleShowToast = (type, message) => {
    console.log("handleShowToast");
    if (type === "success") {
      setShowCompanyFeesModaleDynamic(false);

      toast.success(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      getAllCompanyFees(filtredObject);
    } else if (type === "error") {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const canAccessDynamicCategory = (categoryId) =>
    accessList.DynamicCategories === "ALL" ||
    (accessList.DynamicCategories || []).includes(categoryId);

  const handleCompanyFeeAddModaleDynamic = (category) => {
    try {
      if (category) setSelectedDynamicCategory(category);
      setShowCompanyFeesModaleDynamic(!showCompanyFeesModaleDynamic);
    } catch (err) {
      console.log(err);
    }
  };

  const handleAddExcludedDate = (e) => {
    const { value } = e.target;
    if (!value) return;
    if (filtredObject.excludedDates.includes(value)) return;

    filtredObject.excludedDates = [...filtredObject.excludedDates, value];
    setFiltredObject((prev) => ({
      ...prev,
      excludedDates: filtredObject.excludedDates,
    }));
  };

  const handleRemoveExcludedDate = (date) => {
    filtredObject.excludedDates = filtredObject.excludedDates.filter(
      (el) => el !== date
    );
    setFiltredObject((prev) => ({
      ...prev,
      excludedDates: filtredObject.excludedDates,
    }));
  };

  const handleDownloadCompanyFeesPdf = async (filters) => {
    if (!accessList?.pdf_excel) return;
    try {
      const response = await pdfCompanyFeeGeneratorApi(filters);
      window.open(`${response}`, "_blank");
    } catch (err) {
      console.log(err);
    }
  };

  const handleFilterCompanyFees = async () => {
    try {
      getAllCompanyFees(filtredObject);
    } catch (err) {
      console.log(err);
    }
  };

  const dataByType = useMemo(() => {
    return {
      DYNAMIC: tableData.filter((el) => el.typeOfOp === "DYNAMIC"),
    };
  }, [tableData]);

  return (
    <Card extra={"w-full pb-10 p-4 h-full"}>
      <ToastContainer />

      <Dialog
        size="xl"
        open={showCompanyFeesModaleDynamic}
        handler={handleCompanyFeeAddModaleDynamic}
      >
        <DialogHeader>
          <p className="w-full text-center">
            {selectedDynamicCategory?.category}
          </p>
        </DialogHeader>
        <DialogBody>
          <DYNAMICModale
            key={selectedDynamicCategory?._id}
            closePopup={handleCompanyFeeAddModaleDynamic}
            actionType="new"
            selectedData={null}
            selectedCategory={selectedDynamicCategory}
            showToast={handleShowToast}
            accessList={accessList}
          />
        </DialogBody>
      </Dialog>

      <header className="relative flex flex-col items-center justify-between md:flex-row">
        <div className="mb-5 text-xl font-bold text-navy-700 dark:text-white md:mb-0"></div>
      </header>

      {/* Available company fees */}
      <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-3">
        {companyFeesCategories
          .filter((el) => accessList.Add && canAccessDynamicCategory(el._id))
          .map((el) => (
            <Button
              key={el._id}
              variant="text"
              color="#236571"
              className=""
              onClick={() => handleCompanyFeeAddModaleDynamic(el)}
            >
              <span>Ajouter {el.category}</span>
            </Button>
          ))}
      </div>

      <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-4">
        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Etat (Approuvée) :
          </small>
          <div>
            <select
              label="select Version"
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              defaultValue=""
              name="isAproved"
              value={filtredObject.isAproved}
              onChange={handleFiltersInputChange}
            >
              <option value="">Tous</option>
              <option value="true">Approuvée</option>
              <option value="false">Non Approuvée</option>
            </select>
          </div>
        </div>
        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Etat (Justifié) :
          </small>
          <div>
            <select
              label="select Version"
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              defaultValue=""
              name="isJustify"
              value={filtredObject.isJustify}
              onChange={handleFiltersInputChange}
            >
              <option value="">Tous</option>
              <option value="true">Justifié</option>
              <option value="false">Non Justifié</option>
            </select>
          </div>
        </div>
        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Résponsable :
          </small>
          <div>
            <select
              label="select Version"
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              defaultValue="Tout"
              name="responsable"
              value={filtredObject.responsable}
              onChange={handleFiltersInputChange}
            >
              <option value="">Tous</option>
              {listOfTcp.map((el) => (
                <option value={el._id}>{el.Name}</option>
              ))}
            </select>
          </div>
        </div>
        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Type :
          </small>
          <div>
            <select
              label="select Version"
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              name="typeOfOp"
              value={filtredObject.typeOfOp}
              onChange={handleFiltersInputChange}
            >
              <option value="ALL">Tous</option>
              {companyFeesCategories
                .filter((el) => canAccessDynamicCategory(el._id))
                .map((el) => (
                  <option key={el._id} value={`DYNAMIC:${el._id}`}>
                    {el.category}
                  </option>
                ))}
            </select>
          </div>
        </div>

        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Statut document :
          </small>
          <div>
            <select
              label="select Version"
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              name="docStatus"
              value={filtredObject.docStatus}
              onChange={handleFiltersInputChange}
            >
              <option value="">Tous</option>
              <option value="V">Validé</option>
              <option value="A">Annulé</option>
              <option value="N">En cours</option>
            </select>
          </div>
        </div>

        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Statut paiement :
          </small>
          <div>
            <select
              label="select Version"
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              name="payeStatus"
              value={filtredObject.payeStatus}
              onChange={handleFiltersInputChange}
            >
              <option value="">Tous</option>
              <option value="N">En cours</option>
              <option value="payed">Payée</option>
              <option value="notPayed">Impayée</option>
            </select>
          </div>
        </div>

        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Etat DG :
          </small>
          <div>
            <select
              label="select Version"
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              name="dgValidationStatus"
              value={filtredObject.dgValidationStatus}
              onChange={handleFiltersInputChange}
            >
              <option value="">Tous</option>
              <option value="N">En cours</option>
              <option value="V">Validée</option>
              <option value="A">Annulée</option>
            </select>
          </div>
        </div>

        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Période (Depuis - à) :
          </small>
          <div>
            <input
              type="date"
              id=""
              placeholder=""
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              name="selectedFromDate"
              value={filtredObject.selectedFromDate}
              onChange={handleFiltersInputChange}
            />
            <input
              type="date"
              id=""
              placeholder=""
              className={`mt-2 flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              name="selectedToDate"
              value={filtredObject.selectedToDate}
              onChange={handleFiltersInputChange}
            />
          </div>
        </div>

        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Exclure des jours :
          </small>
          <div>
            <input
              type="date"
              id=""
              placeholder=""
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              value=""
              min={filtredObject.selectedFromDate}
              max={filtredObject.selectedToDate}
              onChange={handleAddExcludedDate}
            />
            <div className="mt-2 flex flex-wrap gap-2">
              {filtredObject.excludedDates.map((date) => (
                <span
                  key={date}
                  className="flex items-center gap-1 rounded-full bg-gray-100 px-3 py-1 text-xs text-navy-700 dark:bg-navy-700 dark:text-white"
                >
                  {date.split("-").reverse().join("/")}
                  <button
                    type="button"
                    className="ml-1 font-bold text-red-500"
                    onClick={() => handleRemoveExcludedDate(date)}
                  >
                    ×
                  </button>
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Filter Buttons */}
        <div>
          {accessList.pdf_excel && (
            <Button
              color="#236571"
              className="mt-5 text-white"
              onClick={() => handleDownloadCompanyFeesPdf(filtredObject)}
            >
              Télécharger PDF
            </Button>
          )}
          <Button
            color="#236571"
            className="mt-5 text-white"
            onClick={() => handleFilterCompanyFees()}
          >
            Filtrer
          </Button>
        </div>

        <div className="flex items-end gap-2">
          <Button
            variant="outlined"
            color="gray"
            onClick={() => {
              const resetFilters = {
                typeOfOp: "ALL",
                isAproved: "",
                isJustify: "",
                responsable: "",
                cvValidationStaus: "",
                fdValidationStatus: "",
                tlValidationStatus: "",
                evenementsValidationStatus: "",
                avocatValidationStatus: "",
                details: "",
                dgValidationStatus: "",
                description: "",
                selectedFromDate: `${new Date().getFullYear()}-01-01`,
                selectedToDate: `${new Date().getFullYear()}-12-31`,
                excludedDates: [],
                docStatus: "",
                payeStatus: "",
              };
              setFiltredObject(resetFilters);
              getAllCompanyFees(resetFilters);
            }}
            className="px-4 py-2 text-xs font-bold"
          >
            Effacer les filtres
          </Button>
        </div>
      </div>

      {isLoading ? (
        <div className="flex w-full items-center justify-center">
          <Spinner className="h-12 w-12" />
        </div>
      ) : (
        <DYNAMIC
          tableData={
            filtredObject.typeOfOp === "ALL" ? dataByType.DYNAMIC : tableData
          }
          refreshTableData={refreshTableData}
          accessList={accessList}
          showToast={handleShowToast}
          selectedFilters={{ ...filtredObject, typeOfOp: "DYNAMIC" }}
        />
      )}
    </Card>
  );
}

export default CompanyFeesTable;
